import { useState } from "react";
import { InputLabel, Typography } from "@mui/material";
import { red } from "@mui/material/colors";

interface CustomInputLabelProps {
  children: React.ReactNode;
  required?: boolean;
  htmlFor?: string;
}

const CustomInputLabel: React.FC<CustomInputLabelProps> = ({
  children,
  required,
  htmlFor,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <InputLabel
      sx={{
        color: "primary.main",
        fontWeight: 600,
        marginBottom: "8px",
        fontSize: "14px",
      }}
      htmlFor={htmlFor}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      {children}
      {required && (
        <Typography
          variant="body1"
          component="span"
          sx={{ color: isFocused ? "primary.main" : red[500] }}
        >
          *
        </Typography>
      )}
    </InputLabel>
  );
};

export default CustomInputLabel;
